<template>

  <table class="table table-borderless table-dfe">
    <thead>
    <tr>
      <th>
        <BkpsCheckBox :value="checkAllRow"
                      @input="$emit('changeCheckAllRow', $event)"/>
      </th>
      <th></th>
      <th>Eventos</th>
      <th>Tipo</th>
      <th>Chave</th>
      <th>Número</th>
      <th>Valor</th>
      <th>Participantes</th>
      <th>Data de emissão</th>
      <th>Data de inclusão</th>
      <th>Data de escrituração</th>
      <th>Origem</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in fiscalDocuments" :key="item.id">
      <td :class="item.xmlStatus.status ? 'marker-green' : 'marker-red'" :title="buildTitle(item)">
        <BkpsCheckBox @input="$emit('changeCheckRow', $event)" v-model="item.checked"/>
      </td>
      <td>
        <BkpsLabel :label="item.label"/>
      </td>
      <td class="nowrap">
        <a @click.prevent="$emit('showEvents', item)" :href="item.key">
          {{ item.lastEvent }}
        </a>
      </td>
      <td>
        {{ item.fiscalDocumentType }}
      </td>

      <td :title="item.key" class="nowrap">
        <a v-if="item.key" :href="item.link" target="_blank">{{ item.key | key }}</a>
        <template v-else>{{ item.key | key }}</template>
        <span>
          <CopyIcon @click="copyKey(item.key)" class="fd-icon ml-1" v-tooltip.right="'Copiar'"/>
        </span>
      </td>

      <td>{{ item.docNumber | docNumber }}</td>
      <td class="nowrap">{{ item.totalValue | currency }}</td>
      <td>
        <ModalParticipants :participants="item.participants"/>
      </td>
      <td>{{ item.issuedAt | datetime }}</td>
      <td>{{ item.includedAt | datetime }}</td>
      <td>{{ item.bookkeepingAt | date }}</td>
      <td>{{ item.originFormatted }}</td>
    </tr>

    </tbody>
  </table>

</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import BkpsLabel from '@/components/shares/specialTag/BkpsLabel'
  import ModalParticipants from '@/components/dfe/ModalParticipants'
  import { CopyIcon } from 'vue-feather-icons'

  export default {
    components: { BkpsCheckBox, BkpsLabel, CopyIcon, ModalParticipants },
    data() {
      return {
        mapShowParticipants: {}
      }
    },
    filters: {
      docNumber(value) {
        value = `${value}`.padStart(9, '0')
        return value.replace(/(\d{3})(\d{3})(\d{3})/g, '$1.$2.$3')
      }
    },
    methods: {
      buildTitle(item) {
        if (item.xmlStatus && item.xmlStatus.description)
          return item.xmlStatus.description
        else
          return ''
      },
      copyKey(key) {
        const input = document.createElement('input');
        input.value = key
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      },
      participant(participants, ...types) {
        if (!participants || participants.length === 0)
          return {}

        return participants.find(e => types.includes(e.fiscalDocumentType)) || {}
      }
    },
    name: 'Table',
    props: {
      checkAllRow: { required: true, type: Boolean },
      fiscalDocuments: { required: true, type: Array }
    }
  }
</script>

<style scoped lang="scss">
  .fd-icon {
    cursor: pointer;
    padding: 4px 0;
    border-radius: 5px;
  }

  .fd-icon:active {
    background: #15CE9A;
    transition: all 0.2s ease-in-out;
  }

</style>
